/* MKB 2026 — Kit builder, part 4 of 5 (see mkb-builder-1.js). */
(function (K) {
  'use strict';
  var ORD = K.ORD, COLORS = K.COLORS, KITE_PTS = K.KITE_PTS, BOARD_PTS = K.BOARD_PTS, WAIST_TXT = K.WAIST_TXT, STRAP_TXT = K.STRAP_TXT, GUIDES = K.GUIDES, COPY = K.COPY, LABEL = K.LABEL, ROLE = K.ROLE;
  var esc = K.esc, uniq = K.uniq, first = K.first, clone = K.clone, num = K.num, ordOf = K.ordOf, interp = K.interp, sized = K.sized, swatch = K.swatch, round1 = K.round1, article = K.article;
  var Builder = K.Builder;

  Builder.prototype.guide = function (sl) {
    var g, k = sl.kind, s = this.st[sl.key], p = s && this.P[s.h], val = null;
    if (k === 'kite') g = sl.role === 'single' ? GUIDES.kite : GUIDES.quiver;
    else if (k === 'bar') g = GUIDES.bar;
    else if (k === 'harness') g = GUIDES.harness;
    else if (k === 'board') g = GUIDES.board;
    else if (k === 'straps') g = (p && p.sizeI >= 0 && p.meta[p.sizeI].vals.some(function (x) { return /\//.test(x); })) ? GUIDES.straps2 : GUIDES.straps4;
    if (!g) return '';
    if (g.by === 'lb') val = this.lb();
    else if (g.by === 'waist') val = this.waist();
    else if (g.by === 'shoe') val = this.shoe();
    else if (g.by === 'kite') { var r = this.rec(sl); val = r ? r.kite : null; }
    var you = -1;
    if (val != null) for (var i = 0; i < g.at.length; i++) { if (g.le ? val <= g.at[i] : val < g.at[i]) { you = i; break; } }
    var html = '<div class="kb-guide" id="' + this.uid + '-g-' + sl.key + '"><p class="kb-guide__cap">' + esc(g.cap) + '</p><div class="kb-guide__scroll"><table><thead><tr>' +
      g.head.map(function (h) { return '<th scope="col">' + esc(h) + '</th>'; }).join('') + '</tr></thead><tbody>';
    g.rows.forEach(function (row, i) {
      html += '<tr' + (i === you ? ' class="is-you"' : '') + '>' + row.map(function (c, j) { return j === 0 ? '<th scope="row">' + esc(c) + (i === you ? ' <em>You</em>' : '') + '</th>' : '<td>' + esc(c) + '</td>'; }).join('') + '</tr>';
    });
    html += '</tbody></table></div><p class="kb-guide__foot">This is a guide, not a rule. Between two sizes? Call us at <a href="tel:' + esc(this.D.tel) + '">' + esc(this.D.phone) + '</a> and we will help you pick.</p></div>';
    return html;
  };

  Builder.prototype.renderSlot = function (sl) {
    var on = this.isOn(sl);
    if (on === false || sl.kind === 'hook') return '';
    var s = this.st[sl.key], c = sl.kind === 'kite' ? COPY[sl.role === 'single' ? 'kite' : sl.role] : (sl.kind === 'bar' && this.pkg.barCount > 1 ? COPY['bar' + sl.idx] : COPY[sl.kind]);
    var label = (sl.role && ROLE[sl.role]) || LABEL[sl.kind];
    var html = '<section class="kb-step' + (this.flag === sl.key ? ' is-flag' : '') + '" data-step="' + sl.key + '" id="' + this.uid + '-' + sl.key + '">' + this.head(c);
    if (c[2] && on === true && !s.skip) {
      var open = !!this.open[sl.key];
      html += '<button type="button" class="kb-help" data-act="help" data-k="' + sl.key + '" aria-expanded="' + open + '" aria-controls="' + this.uid + '-g-' + sl.key + '" data-fk="help-' + sl.key + '"><span class="kb-help__i" aria-hidden="true"></span>' + esc(c[2]) + '</button>';
      if (open) html += this.guide(sl);
    }
    if (on === 'na') {
      return html + '<div class="kb-na"><p><strong>' + esc(label) + 's are coming to the online shop.</strong> Call us and we will pair the right one with your kit.</p>' +
        '<a class="kb-btn kb-btn--line" href="tel:' + esc(this.D.tel) + '">Call ' + esc(this.D.phone) + '</a></div></section>';
    }
    if (s.skip) {
      return html + '<div class="kb-skipped"><span>' + (sl.kind === 'straps' ? 'You already have footstraps.' : 'You already have ' + article(label) + ' ' + esc(label.toLowerCase()) + '.') + ' We left it out.</span>' +
        '<button type="button" class="kb-link" data-act="unskip" data-slot="' + sl.key + '" data-fk="unskip-' + sl.key + '">Add one</button></div></section>';
    }
    html += this.renderTiles(sl.key, sl.list, s.h, sl.kind);
    var p = this.P[s.h];
    if (p) html += this.renderOpts(sl.key, sl.kind, p, s, 'opt');
    if (this.flag === sl.key) html += '<p class="kb-need" role="status">' + esc(this.missing(sl)) + ' to continue.</p>';
    if (sl.kind === 'harness') html += this.renderHook();
    if (!(sl.kind === 'kite' && sl.idx === 0)) {
      html += '<button type="button" class="kb-link kb-skip" data-act="skip" data-slot="' + sl.key + '" data-fk="skip-' + sl.key + '">' + (sl.kind === 'straps' ? 'I already have footstraps' : 'I already have ' + article(label) + ' ' + esc(label.toLowerCase())) + '</button>';
    }
    return html + '</section>';
  };

  Builder.prototype.renderHook = function () {
    var sl = this.slot('hook');
    if (!sl || this.isOn(sl) !== true) return '';
    var s = this.st.hook, html = '<div class="kb-hook' + (this.flag === 'hook' ? ' is-flag' : '') + '" data-step-sub="hook" id="' + this.uid + '-hook">' + this.head(COPY.hook, 'h3');
    if (s.skip) {
      return html + '<div class="kb-skipped"><span>You already have a hook. We left it out.</span><button type="button" class="kb-link" data-act="unskip" data-slot="hook" data-fk="unskip-hook">Add one</button></div></div>';
    }
    html += this.renderTiles('hook', sl.list, s.h, 'hook');
    var p = this.P[s.h];
    if (p) html += this.renderOpts('hook', 'hook', p, s, 'opt');
    if (this.flag === 'hook') html += '<p class="kb-need" role="status">' + esc(this.missing(sl)) + ' to continue.</p>';
    return html + '<button type="button" class="kb-link kb-skip" data-act="skip" data-slot="hook" data-fk="skip-hook">I already have a hook</button></div>';
  };

  Builder.prototype.renderExtras = function () {
    var k = this.pkg, self = this;
    if (!k.addons.length && !k.lessons.length) return '';
    var html = '<section class="kb-step" data-step="extras" id="' + this.uid + '-extras">' + this.head(COPY.extras);
    function group(list, title, note) {
      if (!list.length) return '';
      var h = '<p class="kb-group">' + esc(title) + '</p>' + (note ? '<p class="kb-note kb-note--tight">' + esc(note) + '</p>' : '') + self.renderTiles('extras', list, null, 'extra', true);
      list.forEach(function (x) {
        var e = self.ex[x], p = self.P[x];
        if (!e.on || !p.meta.some(function (m) { return !m.hidden; })) return;
        h += '<div class="kb-xopts" id="' + self.uid + '-x-' + esc(x) + '"><p class="kb-xopts__h">' + esc(self.title(p)) + '</p>' + self.renderOpts(x, 'other', p, e, 'xopt') + '</div>';
      });
      return h;
    }
    html += group(k.addons, 'Gear', '');
    html += group(k.lessons, 'Learn on your new gear', this.D.lessonNote || '');
    return html + '</section>';
  };

  Builder.prototype.renderSummary = function (T) {
    if (!this.pkg) { this.els.sum.innerHTML = ''; return; }
    var self = this, rows = '';
    T.lines.forEach(function (L) {
      var label = L.ex ? (self.pkg.lessons.indexOf(L.ex) >= 0 ? 'Lesson' : 'Extra') : ((L.sl.role && ROLE[L.sl.role]) || LABEL[L.sl.kind]);
      if (L.skip) {
        rows += '<li class="kb-row is-skip"><span class="kb-row__img"><span class="kb-noimg"></span></span><span class="kb-row__txt"><span class="kb-row__lab">' + esc(label) + '</span><span class="kb-row__name">You have one</span></span><span class="kb-row__p">—</span></li>';
        return;
      }
      var st = L.ex ? self.ex[L.ex] : self.st[L.sl.key], kind = L.ex ? 'other' : L.sl.kind;
      var img = (L.v && L.v.img) || (L.p && L.p.img);
      rows += '<li class="kb-row' + (L.todo ? ' is-todo' : '') + '"><span class="kb-row__img">' + self.img(img, 160, '') + '</span><span class="kb-row__txt"><span class="kb-row__lab">' + esc(label) + '</span>' +
        '<span class="kb-row__name">' + esc(L.p ? self.title(L.p) : '') + '</span>' +
        (L.todo ? '<button type="button" class="kb-link kb-row__todo" data-act="goto" data-slot="' + esc(L.ex ? 'x-' + L.ex : L.sl.key) + '">' + esc(L.todo) + '</button>' : '<span class="kb-row__opt">' + esc(L.p ? self.optLabel(kind, L.p, st) : '') + '</span>') +
        '</span><span class="kb-row__p">' + (L.v && !L.todo ? self.money(L.v.p) : '') + '</span></li>';
    });
    this.els.sum.innerHTML = '<section class="kb-sum" data-step="sum" id="' + this.uid + '-sum">' +
      '<div class="kb-sum__list">' + this.head(COPY.sum) + '<ul class="kb-rows">' + rows + '</ul></div>' +
      '<div class="kb-sum__box"><p class="kb-sum__pkg">' + esc(this.pkg.title) + ' package</p>' +
      '<p class="kb-sum__lab">' + (T.from ? 'From' : 'Total') + '</p><p class="kb-sum__total">' + this.money(T.total) + '</p>' +
      this.cta(T, 'sum') +
      '<p class="kb-err" role="alert">' + esc(this.err) + '</p>' +
      '<p class="kb-sum__note">Between two sizes, or not sure? Call us at <a href="tel:' + esc(this.D.tel) + '">' + esc(this.D.phone) + '</a> and we will help you pick.</p></div></section>';
    if (this.sumIO) { this.sumIO.disconnect(); this.sumIO.observe(this.els.sum.firstChild); }
  };

  Builder.prototype.cta = function (T, where) {
    var done = T.ready === T.need && T.need > 0;
    var label = this.busy ? 'Adding…' : done ? 'Add kit to cart' : 'Continue';
    return '<button type="button" class="kb-btn' + (where === 'sum' ? ' kb-btn--full' : '') + (done ? '' : ' is-next') + '" data-act="add" data-fk="add-' + where + '"' + (this.busy ? ' disabled' : '') + '>' + label + '</button>';
  };

  Builder.prototype.renderBar = function (T) {
    if (!this.pkg) { this.els.bar.innerHTML = ''; this.els.bar.classList.remove('is-on'); return; }
    var pct = T.need ? Math.round(T.ready / T.need * 100) : 0;
    var next = T.next ? T.next.msg : 'Your kit is ready.';
    this.els.bar.innerHTML = '<div class="kb-bar__in"><div class="kb-bar__info"><p class="kb-bar__pkg">' + esc(this.pkg.title) + ' package</p>' +
      '<p class="kb-bar__ready"><span class="kb-bar__meter" aria-hidden="true"><i style="width:' + pct + '%"></i></span>' + T.ready + ' of ' + T.need + ' ready<span class="kb-bar__next"> · ' + esc(next) + '</span></p></div>' +
      '<div class="kb-bar__price"><span>' + (T.from ? 'From' : 'Total') + '</span><strong>' + this.money(T.total) + '</strong></div>' + this.cta(T, 'bar') + '</div>' +
      (this.err ? '<p class="kb-bar__err" role="alert">' + esc(this.err) + '</p>' : '');
    this.syncBar();
  };
  Builder.prototype.syncBar = function () { this.els.bar.classList.toggle('is-on', !!this.pkg && !this.sumVisible); };

  /* ---------- stage (sticky preview on desktop) ---------- */
  Builder.prototype.buildStage = function () {
    if (!this.els.stage) return;
    this.els.stage.innerHTML = '<div class="kb-stage"><div class="kb-stage__fig"><img class="kb-stage__img" alt="" decoding="async"></div>' +
      '<div class="kb-stage__cap" aria-live="polite"></div><div class="kb-kit"><p class="kb-kit__h">Your kit</p><ul class="kb-kit__list"></ul></div></div>';
    this.stImg = this.els.stage.querySelector('.kb-stage__img');
    this.stCap = this.els.stage.querySelector('.kb-stage__cap');
    this.stKit = this.els.stage.querySelector('.kb-kit__list');
    var self = this;
    this.stImg.addEventListener('load', function () { self.stImg.classList.add('is-in'); });
  };
  Builder.prototype.stageFor = function (key) {
    if (!this.pkg) return null;
    if (key === 'extras') {
      var self = this, h = this.lastExtra || first(this.pkg.addons.concat(this.pkg.lessons), function (x) { return self.ex[x].on; });
      if (h) { var e = this.ex[h], p = this.P[h], v = this.variant(p, e.sel); return { lab: this.pkg.lessons.indexOf(h) >= 0 ? 'Lesson' : 'Extra', p: p, v: v, opt: this.optLabel('other', p, e) }; }
      key = 'pump';
    }
    var sl = this.slot(key) || this.slot('kite0');
    if (!sl || this.isOn(sl) !== true) sl = this.slot('kite0');
    var s = this.st[sl.key], p2 = this.P[s.h];
    if (!p2 || s.skip) return { lab: (sl.role && ROLE[sl.role]) || LABEL[sl.kind], skip: true };
    var v2 = this.variant(p2, s.sel);
    return { lab: (sl.role && ROLE[sl.role]) || LABEL[sl.kind], p: p2, v: v2, opt: this.optLabel(sl.kind, p2, s) };
  };
  Builder.prototype.renderStage = function (T) {
    if (!this.els.stage) return;
    this.els.stage.classList.toggle('is-empty', !this.pkg);
    if (!this.pkg) return;
    var f = this.stageFor(this.focusKey || 'kite0');
    if (f) {
      var src = f.p ? sized((f.v && f.v.img) || f.p.img, 1200) : '';
      if (src && this.stImg.getAttribute('src') !== src) {
        this.stImg.classList.remove('is-in');
        this.stImg.setAttribute('src', src);
        if (this.stImg.complete) this.stImg.classList.add('is-in');
      } else if (!src) { this.stImg.removeAttribute('src'); this.stImg.classList.remove('is-in'); }
      this.stCap.innerHTML = '<p class="kb-stage__lab">' + esc(f.lab) + '</p>' +
        (f.p ? '<p class="kb-stage__name">' + esc((f.p.brand ? f.p.brand + ' ' : '') + this.title(f.p)) + '</p><p class="kb-stage__opt">' + esc(f.opt || '') + (f.v && f.v.a ? ' <span>' + this.money(f.v.p) + '</span>' : '') + '</p>' : '<p class="kb-stage__name">You already have one</p>');
    }
    var self = this, html = '';
    T.lines.forEach(function (L) {
      var key = L.ex ? 'x-' + L.ex : L.sl.key, label = L.ex ? self.title(L.p) : ((L.sl.role && ROLE[L.sl.role]) || LABEL[L.sl.kind]);
      var img = L.skip ? '' : ((L.v && L.v.img) || (L.p && L.p.img));
      var cls = L.skip ? 'is-skip' : L.todo ? 'is-todo' : 'is-done';
      var active = !L.ex && (self.focusKey === key || (self.focusKey === 'harness' && key === 'hook'));
      html += '<li><button type="button" class="kb-kit__item ' + cls + (active ? ' is-active' : '') + '" data-act="goto" data-slot="' + esc(key) + '" title="' + esc(label + (L.todo ? ' — ' + L.todo : '')) + '" aria-label="' + esc(label + (L.skip ? ', you have one' : L.todo ? ', ' + L.todo : ', ready')) + '">' + (img ? self.img(img, 160, '') : '<span class="kb-noimg"></span>') + '</button></li>';
    });
    this.stKit.innerHTML = html;
  };

  Builder.prototype.onScroll = function () {
    if (!this.pkg) return;
    var steps = this.root.querySelectorAll('[data-kb-dyn] .kb-step[data-step]');
    var line = window.innerHeight * 0.42, key = null;
    for (var i = 0; i < steps.length; i++) { if (steps[i].getBoundingClientRect().top < line) key = steps[i].getAttribute('data-step'); }
    if (!key) key = 'kite0';
    if (key !== this.focusKey) { this.focusKey = key; this.renderStage(this.totals()); }
  };
})(window.MKBKB);